export default [
    {
        "id": "blog-container",
        "html": require('./blog-container/html').default,
        "css": require('./blog-container/css').default,
        "cssTablet": require('./blog-container/cssTablet').default,
        "cssMobile": require('./blog-container/cssMobile').default,
        "scss": require('./blog-container/scss').default,
        "scssTablet": require('./blog-container/scssTablet').default,
        "scssMobile": require('./blog-container/scssMobile').default
    }
]